import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=2471b15e&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProgressBar.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2471b15e",
  null
  
)

export default component.exports